module.exports = __webpack_public_path__ + "media/images/delete-icon-d750f1cab3cb029d936d02dec284b15b.svg";